import React from "react"
import classNames from "classnames"

import Link from "components/Link"

import { ReactComponent as ChevronRightSVG } from "assets/Icon/Chevron Right.svg"
import { ReactComponent as CarSVG } from "assets/Icon/Car.svg"
import { ReactComponent as TruckSVG } from "assets/Icon/Truck.svg"
import { ReactComponent as BikeSVG } from "assets/Icon/Moped.svg"
import { ReactComponent as PersonSVG } from "assets/Icon/Person.svg"
import { ReactComponent as GlobeSVG } from "assets/Icon/Globe.svg"
import { ReactComponent as ProblemSVG } from "assets/Icon/Problem.svg"

import "./CarButton.sass"

export function VehicleIcon({ vehicle_type, ...rest }) {
  switch (vehicle_type.toLowerCase()) {
    case "car":
      return <CarSVG {...rest} />
    case "truck":
      return <TruckSVG {...rest} />
    case "bike":
      return <BikeSVG {...rest} />
    case "unknown":
      return <CarSVG {...rest} />
    default:
      return false
  }
}

const CarButton = ({
  make_and_model = "",
  vehicle_type = "car",
  owner_count,
  is_imported = false,
  is_anomalous = false,
  is_warning = false,
  vin,
  children,
  ...rest
}) => {
  const carButtonClassName = classNames({
    CarButton: true,
    hasChildren: !!children,
  })
  return (
    <div className={carButtonClassName} {...rest}>
      <Link to={`/search/${vin}`}>
        <div className="car-data">
          <div className="make_and_model">{make_and_model}</div>
          <div className="details">
            <span className="detail vehicle">
              <VehicleIcon vehicle_type={vehicle_type} />
            </span>
            {owner_count && (
              <span className="detail owner">
                {renderOwnerCount(owner_count)}
              </span>
            )}
            {is_imported && (
              <span className="detail import">
                {renderImportedStatus(is_imported)}
              </span>
            )}
            {is_anomalous ? (
              <span className="detail anomaly">
                {renderAnomalyStatus(is_anomalous)}
              </span>
            ) : (
              is_warning && (
                <span className="detail warning">
                  {renderAnomalyStatus(is_warning)}
                </span>
              )
            )}
          </div>
        </div>
        {children && <div className="children">{children}</div>}
      </Link>
      <ChevronRightSVG className="chevron-right" />
    </div>
  )
}

// function renderVehicleType(vehicle_type) {
//   switch (vehicle_type.toLowerCase()) {
//     case "car":
//       return <CarSVG />
//     case "truck":
//       return <TruckSVG />
//     case "bike":
//       return <BikeSVG />
//     case "unknown":
//       return <CarSVG />
//     default:
//       return false
//   }
// }

function renderOwnerCount(owner_count) {
  if (parseInt(owner_count) === 1) {
    return (
      <>
        <PersonSVG /> Prvi lastnik
      </>
    )
  }

  if (owner_count === Number.POSITIVE_INFINITY) {
    return (
      <>
        <PersonSVG /> Več lastnikov
      </>
    )
  }

  return (
    <>
      <PersonSVG /> {owner_count}. lastnik
    </>
  )
}

function renderImportedStatus(is_imported) {
  if (!is_imported) {
    return false
  }

  return (
    <>
      <GlobeSVG /> Uvoženo
    </>
  )
}

function renderAnomalyStatus(is_anomalous) {
  if (!is_anomalous) {
    return false
  }

  return (
    <>
      <ProblemSVG />
    </>
  )
}

export default CarButton
